import router from "@/router";
import { Loading } from "element-ui";
import {getSessionData, setSessionData} from "@/utils/commonApi";
import store from "@/store";
import { getWhiteList, getPublicList } from "@/config";

// import { Login, LoginOut } from "@/utils/login";
let loader = null;
const dev = process.env.NODE_ENV === "development";
router.beforeEach((to, from, next) => {
  // next();
  // let menuList = {
  //   menu_list:[
  //     {
  //       "id": "210631910980845568",
  //       "code": "indexPage",
  //       "name": "首页概览",
  //       "route": "/indexPage",
  //       "description": "",
  //       "icon":'el-icon-s-home',
  //       "menu_list": [],
  //       "operation_list": []
  //     },
  //     {
  //       "id": "210631910980845568",
  //       "code": "classManage",
  //       "name": "分类管理",
  //       "route": "/classManage",
  //       "description": "",
  //       "icon":'el-icon-s-finance',
  //       "menu_list": [],
  //       "operation_list": []
  //     },
  //     {
  //       "id": "210631910980845568",
  //       "code": "resourceManage",
  //       "name": "资源管理",
  //       "route": "/resourceManage",
  //       "description": "",
  //       "icon":'el-icon-s-cooperation',
  //       "menu_list": [
  //         {
  //           "id": "210631966452613120",
  //           "code": "videoManage",
  //           "name": "视频",
  //           "route": "/videoManage",
  //           "description": "",
  //           "menu_list": [],
  //           "operation_list": [],
  //         },
  //         {
  //           "id": "210631966452613120",
  //           "code": "imageManage",
  //           "name": "图片",
  //           "route": "/imageManage",
  //           "description": "",
  //           "menu_list": [],
  //           "operation_list": [],
  //         },
  //         {
  //           "id": "210631966452613120",
  //           "code": "fileManage",
  //           "name": "课件",
  //           "route": "/fileManage",
  //           "description": "",
  //           "menu_list": [],
  //           "operation_list": [],
  //         },
  //       ],
  //       "operation_list": []
  //     },
  //     {
  //       "id": "210631910980845568",
  //       "code": "studyManage",
  //       "name": "学习管理",
  //       "route": "/studyManage",
  //       "description": "",
  //       "icon":'el-icon-s-cooperation',
  //       "menu_list": [
  //         {
  //           "id": "210631966452613120",
  //           "code": "onlineCourseManage",
  //           "name": "在线课程",
  //           "route": "/onlineCourseManage",
  //           "description": "",
  //           "menu_list": [],
  //           "operation_list": [],
  //         },
  //       ],
  //       "operation_list": []
  //     },
  //     {
  //       "id": "210631910980845568",
  //       "code": "resourcesManage1",
  //       "name": "学员管理",
  //       "route": "/resourcesManage",
  //       "description": "",
  //       "icon":'el-icon-s-cooperation',
  //       "menu_list": [
  //         {
  //           "id": "210631966452613120",
  //           "code": "videoPage",
  //           "name": "学员",
  //           "route": "/videoPage",
  //           "description": "",
  //           "menu_list": [],
  //           "operation_list": [],
  //         },
  //         {
  //           "id": "210631966452613120",
  //           "code": "videoPage",
  //           "name": "部门",
  //           "route": "/videoPage",
  //           "description": "",
  //           "menu_list": [],
  //           "operation_list": [],
  //         },
  //       ],
  //       "operation_list": []
  //     },
  //     {
  //       "id": "210631910980845568",
  //       "code": "resourcesManage1",
  //       "name": "系统设置",
  //       "route": "/resourcesManage",
  //       "description": "",
  //       "icon":'el-icon-s-cooperation',
  //       "menu_list": [
  //         {
  //           "id": "210631966452613120",
  //           "code": "videoPage",
  //           "name": "管理人员",
  //           "route": "/videoPage",
  //           "description": "",
  //           "menu_list": [],
  //           "operation_list": [],
  //         },
  //         {
  //           "id": "210631966452613120",
  //           "code": "videoPage",
  //           "name": "管理日志",
  //           "route": "/videoPage",
  //           "description": "",
  //           "menu_list": [],
  //           "operation_list": [],
  //         },
  //       ],
  //       "operation_list": []
  //     },
  //   ]
  // }
  // store.dispatch("GenerateRoutes",menuList);
  // return
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "西安开放大学";
  }
  loader = Loading.service({
    lock: true,
    text: "正在拼命加载...",
    spinner: "el-icon-loading",
    background: "rgba(255,255,255,0.7)",
    customClass: "req-loading-class",
  });
  if (to.query && to.query.access_token) {
      sessionStorage.setItem("token", to.query.access_token);
      router.replace({ path: to.path })
}
  store.dispatch('setUserPermission',to);
  if(getSessionData("roleData")){
    // if(!getSessionData("menuInfo")){
      store.dispatch("GetUserInfo",to).then((res) => {
        setSessionData("loginUserInfo", res);
        setSessionData("menuInfo", res.menu);
        store.dispatch("GenerateRoutes", res.menu);
      });
    // }
    // store.dispatch("GenerateRoutes", "");
    if(to.path==='/roleTag')return next('/')
    next()
  }else{
    if (getWhiteList().includes(to.path))return next()
    next('/roleTag')
  }
});

router.afterEach((to, from, next) => {
  loader.close();
});
